import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { EnumStorageKeys, StorageService } from '@services/storage.service';

/**
 * Estado do menu lateral (modo colapsado só com ícones).
 * O colapso só tem efeito quando o menu está fixo (desktop / split-pane visível).
 */
@Injectable({
    providedIn: 'root'
})
export class SideMenuStateService {

    private readonly userCollapsed = new BehaviorSubject<boolean>(false);

    private readonly paneVisible = new BehaviorSubject<boolean>(false);

    /** true quando o menu está fixo (desktop) */
    public readonly PaneVisible: Observable<boolean> = this.paneVisible.asObservable();

    /** true quando o menu deve ser mostrado só com ícones (preferência + desktop) */
    public readonly Collapsed: Observable<boolean> = combineLatest([this.userCollapsed, this.paneVisible]).pipe(
        map(([collapsed, visible]) => collapsed && visible),
        distinctUntilChanged()
    );

    constructor(private StorageService: StorageService) { }

    /** Carrega a preferência guardada. Chamar depois do StorageService.Init. */
    async Init() {
        const saved = await this.StorageService.Get(EnumStorageKeys.MenuCollapsed);

        this.userCollapsed.next(saved === true);
    }

    public SetPaneVisible(visible: boolean) {
        this.paneVisible.next(visible);
    }

    /** Alterna entre menu expandido e colapsado (ignorado fora do desktop). */
    public async Toggle() {

        if (!this.paneVisible.value)
            return;

        const next = !this.userCollapsed.value;

        this.userCollapsed.next(next);

        await this.StorageService.Save(EnumStorageKeys.MenuCollapsed, next);
    }
}
